import { TableBody, TableColumnContainer, TableColumnView, TableView } from "components/shared";
import React from "react";

import "./styles.css";

/**
 * @function ImportFileAdditionalValuesTable
 * @return {React.Component}
 * @exported true
 * @description The Import File Additional Values table for the ImportFileAdditionalValuesWidget.
 */
export default function ImportFileAdditionalValuesTable(props) {
    return (
        <TableView className="import-file-additional-values-table">
            <TableColumnContainer>
                <TableColumnView className="type-col" text="Type" />
                <TableColumnView className="value-col" text="Value" />
                <TableColumnView className="delete-col" text="Delete" />
            </TableColumnContainer>
            <TableBody>
                {/*  */}
            </TableBody>
        </TableView>
    )
}
